<!--
 * @Author: your name
 * @Date: 2021-10-09 14:06:48
 * @LastEditTime: 2021-10-14 18:53:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\views\user\accunt.vue
-->
<template>
  <div class="user-control" :style="{ fontSize: 'var(--global-page-font-size, 16px)' }">
    <h3>用户卷分配</h3>
    <div class="top">
      <el-button size="mini" type="primary" @click="$router.push('/user')">返回</el-button>
    </div>
    <div class="header">
      <div>
        <el-radio
          v-for="(i, x) in types"
          :key="x"
          v-model="type"
          :label="i"
          @change="typeChange"
        />
      </div>
      <div>
        <el-button size="mini" type="primary" @click="submit">保存</el-button>
      </div>
    </div>
    <div class="control-content">
      <el-tree
        ref="eltree"
        class="eltree"
        :data="tableData"
        :props="props"
        node-key="sid"
        show-checkbox
        default-expand-all
        :default-checked-keys="defaultArr"
        @check-change="checkChange"
      >
        <div slot-scope="{ data }" class="custom-tree-node">
          <span>{{ data.name }}</span>
          <span v-if="data.other" class="other-bind">{{ data.other }}</span>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { gettype, getchapter, chapter2u, getfile, file2u } from '@/api/user'
export default {
  name: 'UserControl',
  data() {
    return {
      tableData: [],
      type: '',
      types: [],
      props: {
        label: 'name',
        children: 'children'
      },
      defaultArr: [], // 用户已选中列表
      checkArr: []
    }
  },
  created() {
    gettype().then(res => {
      if (res.code === 200 && res.data) {
        this.types = res.data
        this.type = res.data[0]
        this.getChapter()
      }
    })
  },
  methods: {
    checkChange(data, checked, indeterminate) {
      if (!data.children) {
        if (!(this.checkArr.some(i => i.sid === data.sid))) {
          this.checkArr.push({
            sid: data.sid,
            id: data.id,
            type: checked ? 1 : 2
          })
        } else {
          for (let index = 0; index < this.checkArr.length; index++) {
            this.checkArr[index].type = checked ? 1 : 2
          }
        }
      }
    },
    submit() {
      let chapter = []
      // const arr = this.$refs.eltree.getCheckedNodes()
      const childrenArr = []
      this.tableData.forEach(i => {
        if (i.children?.length > 0) {
          for (let index = 0; index < i.children.length; index++) {
            const item = i.children[index]
            childrenArr.push(item)
            // if (item.children?.length > 0) {
            //   for (let si = 0; si < item.children.length; si++) {
            //     childrenArr.push(item.children[si])
            //   }
            // }
          }
        }
      })
      let newArr = []
      newArr = this.checkArr.filter(i => {
        return !(!(this.defaultArr.some(item => item === i.sid)) && i.type === 2) && !(this.defaultArr.some(item => item === i.sid) && i.type === 1)
      })
      chapter = newArr.map(i => {
        return {
          id: i.id,
          userid: this.$route.params.id,
          type: i.type
        }
      })
      if (chapter.length < 1) {
        this.$message.warning('未改动！')
        return
      }
      file2u({ file: chapter }).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功！')
          this.typeChange()
        }
      }).catch(err => {
        window.console.log(err)
      })
    },
    arrReset(arr) {
      // 格式化树形结构
      const newArr = []
      if (arr?.length > 0) {
        arr.forEach((item, index) => {
          const fData = { name: item.dir, sid: index + '', children: [] }
          if (item.file?.length > 0) {
            item.file.forEach((i, x) => {
              const zData = {
                name: i.filename,
                sid: fData.sid + x,
                id: i.id,
                type: i.type,
                other: i.other || ''
              }
              if (i.type === 3 || i.type === 5) {
                this.defaultArr.push(zData.sid)
              }
              fData.children.push(zData)
            })
          }
          newArr.push(fData)
        })
      }
      return newArr
    },
    typeChange() {
      this.defaultArr = []
      this.checkArr = []
      this.tableData = []
      this.getChapter()
    },
    getChapter() {
      getfile({ userid: this.$route.params.id, dir: this.type }).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = this.arrReset(res.data)
        }
      })
    }
  }
}
</script>

<style lang="less">
.user-control {
  font-size: var(--global-page-font-size, 16px);
  padding: 10px;

  .el-button,
  .el-radio,
  .el-radio__label,
  .el-tree,
  .el-tree-node__label,
  .custom-tree-node,
  .other-bind {
    font-size: inherit;
  }

  > h3 {
    text-align: center;
  }
  .header {
    padding: 10px 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .control-content {
    // max-width: 800px;
    // margin: 0 auto;
    height: 80vh;
    border: 1px solid #ccc;
    .eltree {
      background-color: transparent;
      max-height: 100%;
      overflow: auto;
      .other-bind{
        font-size: inherit;
        margin-left: 20px;
        margin-right: 10px;
        float: right;
        // color: skyblue;
      }
    }
  }
}
</style>
